import { GetReportDto, ProcessReportDto, ReportResponseDto } from 'src/dto/report.dto'
import { ReportService } from 'src/services/api/report.service'

export class ReportController {
  private service: ReportService

  constructor() {
    this.service = new ReportService()
  }

  public async getReport(username: string, idRelatorio: string): Promise<ReportResponseDto> {
    const response = await this.service.getReport(username, idRelatorio)
    return response.data
  }

  public async processReport(farmId: string, processReportDto: ProcessReportDto): Promise<GetReportDto> {
    const response = await this.service.processReport(farmId, processReportDto)
    return response.data
  }
}
